export default __webpack_public_path__ + "static/media/otta.f3fb33bb.jpg";